import { Routes } from '@angular/router';
import { AuthGuard } from './shared/auth.guard.service';
import { SecuredComponent } from './views/appviews/secured.component';
import { BasicLayoutComponent } from './components/common/layouts/basicLayout.component';
import { BlankLayoutComponent } from './components/common/layouts/blankLayout.component';
import { LoginComponent } from './views/appviews/login.component';
import { StarterViewComponent } from './views/appviews/starterview.component';
import { CategoryNotificationComponent } from './components/common/notification/category-notification.component';

export const ROUTES: Routes = [
	// Main redirect
	{ path: '', redirectTo: 'starterview', pathMatch: 'full' },

	// Every authenticated section is a child of a single BasicLayoutComponent so the layout —
	// and with it the navigation pane and its assistant panel — survives navigation between
	// sections instead of being destroyed and rebuilt.
	{
		path: '', component: BasicLayoutComponent,
		children: [
			{ path: 'starterview', component: StarterViewComponent },
			{ path: 'securedview', component: SecuredComponent, canActivate: [AuthGuard] },
			{ path: 'category-Notification', component: CategoryNotificationComponent, canActivate: [AuthGuard] },
			{
				path: '360view', canActivate: [AuthGuard],
				loadChildren: () => import('./views/rail360view/rail360-view-routing.module').then(m => m.Rail360ViewRoutingModule)
			},
			{
				path: 'fleet/serviceevent', canActivate: [AuthGuard],
				loadChildren: () => import('./views/service-event/service-event.module').then(m => m.ServiceEventModule)
			},
			{
				path: 'fleet/programwork', canActivate: [AuthGuard],
				loadChildren: () => import('./views/program-work/program-work.module').then(m => m.ProgramWorkModule)
			},
			{
				path: 'commercial/customer', canActivate: [AuthGuard],
				loadChildren: () => import('./views/customer/customer.module').then(m => m.CustomerModule)
			},
			{
				path: 'commercial/railcar', canActivate: [AuthGuard],
				loadChildren: () => import('./views/railcar/railcar.module').then(m => m.RailcarModule)
			},
			{
				path: 'commercial/trackandtrace', canActivate: [AuthGuard],
				loadChildren: () => import('./views/track-and-trace/track-and-trace-routing.module').then(m => m.TrackAndTraceRoutingModule)
			},
			{
				path: 'fleet/facility', canActivate: [AuthGuard],
				loadChildren: () => import('./views/facility/facility.module').then(m => m.FacilityModule)
			},
			{
				path: 'storage', canActivate: [AuthGuard],
				loadChildren: () => import('./views/storage/storage.module').then(m => m.StorageModule)
			},
			{
				path: 'freight', canActivate: [AuthGuard],
				loadChildren: () => import('./views/freight/freight.module').then(m => m.FreightModule)
			},
			{
				path: 'carrepairbilling', canActivate: [AuthGuard],
				loadChildren: () => import('./views/car-repair-billing/car-repair-billing.module').then(m => m.CarRepairBillingModule)
			},
			{
				path: 'inboxinvoice', canActivate: [AuthGuard],
				loadChildren: () => import('./views/inbox-invoice/inbox-invoice.module').then(m => m.InboxInvoiceModule)
			},
			{
				path: 'fleet/report', canActivate: [AuthGuard],
				loadChildren: () => import('./views/reporting/reporting.module').then(m => m.ReportingModule)
			},
			{
				path: 'fleet/dashboard', canActivate: [AuthGuard],
				loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
			},
			{
				path: 'commercial/lease', canActivate: [AuthGuard],
				loadChildren: () => import('./views/lease/lease-routing.module').then(m => m.LeaseRoutingModule)
			},
			{
				path: 'commercial/carhire', canActivate: [AuthGuard],
				loadChildren: () => import('./views/carhire/carhire-routing.module').then(m => m.CarhireRoutingModule)
			},
			{
				path: 'commercial/documents', canActivate: [AuthGuard],
				loadChildren: () => import('./views/docmanager/docmanager-routing.module').then(m => m.DocManagerRoutingModule)
			},
			{
				path: 'commercial/baserental', canActivate: [AuthGuard],
				loadChildren: () => import('./views/base-rental/base-rental.module').then(m => m.BaseRentalModule)
			},
			{
				path: 'fleet/repairtemplate', canActivate: [AuthGuard],
				loadChildren: () => import('./views/repair-template/repair-template.module').then(m => m.RepairTemplateModule)
			},
			{
				path: 'fleet/shopportal', canActivate: [AuthGuard],
				loadChildren: () => import('./views/shop-portal-management/shop-portal-management-routing.module').then(m => m.ShopPortalManagementRoutingModule)
			},
			{
				path: 'baserental', canActivate: [AuthGuard],
				loadChildren: () => import('./views/base-rental/base-rental.module').then(m => m.BaseRentalModule)
			},
			{
				path: 'carhire', canActivate: [AuthGuard],
				loadChildren: () => import('./views/carhire/carhire-routing.module').then(m => m.CarhireRoutingModule)
			},
			{
				path: 'commercial/report', canActivate: [AuthGuard],
				loadChildren: () => import('./views/reporting/reporting.module').then(m => m.ReportingModule)
			},
			{
				path: 'tankcarequalization', canActivate: [AuthGuard],
				loadChildren: () => import('./views/tankcar-equalization/tankcar-equalization-routing.module').then(m => m.TankcarEqualizationRoutingModule)
			},
			{
				path: 'admin', canActivate: [AuthGuard],
				loadChildren: () => import('./views/service-event/service-event.module').then(m => m.ServiceEventModule)
			},
		]
	},
	{
		path: '', component: BlankLayoutComponent,
		children: [
			{ path: 'login', component: LoginComponent },
		]
	},

	// Handle all other routes
	{ path: '**', redirectTo: 'starterview' }
];
